import { render, staticRenderFns } from "./Apontamentos.vue?vue&type=template&id=503401a0&"
import script from "./Apontamentos.vue?vue&type=script&lang=js&"
export * from "./Apontamentos.vue?vue&type=script&lang=js&"
import style0 from "./Apontamentos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports